module.exports = __webpack_public_path__ + "img/nic-stone.023ec605.png";